import * as P from 'prop-types';

const propTypes = {
  open: P.bool.isRequired,
  clickClose: P.func.isRequired,
  setWarrantyLoading: P.func.isRequired,
  handleAlert: P.func.isRequired,
};

export default {
  propTypes,
  defaultProps: {},
};
